/**
 * 帮助中心访问权限
 */
export const NEWS_PAGE_UUID = '41097eb8-4cd0-4e7d-9f6f-450ef84be783'

/**
 * 帮助中心操作权限
 */
export const NEWS_ACTION_UUID = 'c82e3ead-d430-454e-8e7c-01d7635cc0a4'
